/**
 * A region drawn for reading.
 *
 * Every field inside — Input, Textarea, Select, Checkbox, Switch, Combobox, in
 * either kit — shows its value as text, with no control. It is for a viewer who
 * may see settings but not change them. The rule (CLAUDE.md) is that an
 * affordance the user lacks is absent, not disabled; a form of greyed-out
 * controls reads as broken, and was how 144 fields across the apps told a
 * viewer they could not edit (audit 35, U5). Edit-only actions inside — Save,
 * Add, Remove — are the page's to leave out (`{canEdit ? <Button/> : null}`).
 */

import { createContext, useContext, type ReactNode } from 'react';

const Reading = createContext(false);

export function ReadOnly({ when = true, children }: { when?: boolean; children: ReactNode }) {
  return <Reading.Provider value={when}>{children}</Reading.Provider>;
}

/** Whether the field is inside a {@link ReadOnly} region that is reading. */
export function useReadOnly(): boolean {
  return useContext(Reading);
}

/** A field's value as it reads: its text, or a dash for nothing. */
export function readValue(value: unknown): string {
  if (value === undefined || value === null || value === '') return '—';
  return String(value);
}
